const MAX_AGE = 60 * 60 * 1000;
const key = (uid, kind) => `jobseeqr:upgrade:${uid}:${kind}`;
const safePath = (path) => typeof path === 'string' && /^\/(?:job\/[^/?#]+|opportunities|career-coach|career-paths|configure-scout|learning-pathways|mock-interview|ask-anything|company-radar|profile)(?:\?[^#]*)?$/.test(path);

// UI continuity only. Neither drafts nor return destinations grant access.
export function saveUpgradeDraft(uid, kind, value) {
  if (!uid) return;
  try { sessionStorage.setItem(key(uid, kind), JSON.stringify({ value, at: Date.now() })); } catch { /* The current screen still keeps its state. */ }
}

export function readUpgradeDraft(uid, kind) {
  if (!uid) return null;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key(uid, kind)) || 'null');
    return saved && Date.now() - saved.at < MAX_AGE ? saved.value : null;
  } catch { return null; }
}

export function clearUpgradeDraft(uid, kind) {
  try { sessionStorage.removeItem(key(uid, kind)); } catch { /* Storage may be unavailable. */ }
}

export function rememberUpgradeIntent(uid, destination) {
  const target = destination || { path: window.location.pathname + window.location.search };
  if (safePath(target.path)) saveUpgradeDraft(uid, 'return', target);
}

export function takeUpgradeIntent(uid) {
  const target = readUpgradeDraft(uid, 'return');
  clearUpgradeDraft(uid, 'return');
  return safePath(target?.path) ? target : null;
}

export function coachResetDate(month, language = 'en') {
  if (!/^\d{4}-\d{2}$/.test(month || '')) return '';
  const [year, number] = month.split('-').map(Number);
  if (number < 1 || number > 12) return '';
  // The quota resets at the start of the UTC calendar month, as on the server.
  return new Intl.DateTimeFormat(language === 'ar' ? 'ar-LB' : 'en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(new Date(Date.UTC(year, number, 1)));
}
